<script>
export let temperature;
</script>

<style>
div {
    border-bottom: 3px solid #333;
    border-top: 3px solid #333;
    margin: 8px 32px 20px;
    padding: 6px 12px;
}
</style>

<div>
    <strong>{temperature}°C</strong>
</div>
